const ChartReducer = (state, action) => {
  switch (action.type) {
    case "SET_DATA_TRAIN_DETENTION_WISE":
      return {
        ...state,
        trainDetentionCodeWise: {
          ...state.trainDetentionCodeWise,
          data: action.payload,
          time_duration: action.payload.data[0].time_duration,
        },
      };
    case "SET_BEST_SHEET_DATA_BEGAN":
      return {
        ...state,
        bestSheetDataObj: {
          ...state.bestSheetDataObj,
          loading: true,
        },
      };
    case "SET_BEST_SHEET_DATA":
      return {
        ...state,
        bestSheetDataObj: {
          ...state.bestSheetDataObj,
          bestSheetData: action.payload.bestsheet,
          fyTotal: action.payload.total,
          columnName: action.payload.formattedColumns,
          loading: false,
        },
      };
    case "SET_BEST_SHEET_DATA_FAIL":
      return {
        ...state,
        bestSheetDataObj: {
          ...state.bestSheetDataObj,
          loading: false,
          error: true,
        },
      };
    case "SET_BEST_SHEET_DATA_FETCH_END":
      return {
        ...state,
        bestSheetDataObj: {
          ...state.bestSheetDataObj,
          loading: false,
        },
      };
    case "SET_VISIBLE_TABLE":
      return {
        ...state,
        bestSheetDataObj: {
          ...state.bestSheetDataObj,
          visibleTable: action.payload,
        },
      };
    //////////////////////////COMMODITY///////////////////////////////////RAIL_ROAD
    case "SET_COMMODITY_WISE_DATA_BEGAN":
      return {
        ...state,
        commodityWiseLObj: { ...state.commodityWiseLObj, loading: true },
      };
    case "SET_COMMODITY_WISE_DATA":
      return {
        ...state,
        commodityWiseLObj: {
          ...state.commodityWiseLObj,
          commodityWiseLo: action.payload.communityloding,
          fyTotal: action.payload.total,
          visibleTable: {},
          loading: false,
        },
      };
    case "SET_COMMODITY_WISE_DATA_FAIL":
      return {
        ...state,
        commodityWiseLObj: {
          ...state.commodityWiseLObj,
          loading: false,
          error: action.payload,
        },
      };
    case "SET_COMMODITY_WISE_DATA_FETCH_END":
      return {
        ...state,
        commodityWiseLObj: {
          ...state.commodityWiseLObj,
          loading: false,
        },
      }; //////////////////////////RAIL_ROAD///////////////////////////////////
    case "SET_RAIL_ROAD_WISE_DATA_BEGAN":
      return {
        ...state,
        railRoadObj: { ...state.railRoad, loading: true },
      };
    case "SET_RAIL_ROAD_WISE_DATA":
      return {
        ...state,
        railRoadObj: {
          ...state.railRoadObj,
          railRoad: action.payload.railroddata,
          fyTotal: action.payload.total,
          visibleTable: {},
          loading: false,
        },
      };
    case "SET_RAIL_ROAD_WISE_DATA_FAIL":
      return {
        ...state,
        railRoadObj: {
          ...state.railRoadObj,
          loading: false,
          error: action.payload,
        },
      };
    case "SET_RAIL_ROAD_WISE_FETCH_END":
      return {
        ...state,
        railRoadObj: {
          ...state.railRoadObj,
          loading: false,
        },
      };
    default:
      throw new Error(`No Matching "${action.type}" - action type`);
  }
};

export default ChartReducer;
